var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector, OnChanges } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConfigurationService } from '@app/shared/services/appconfigration.service';
var DepotLocationMultiSelectComponent = /** @class */ (function (_super) {
    __extends(DepotLocationMultiSelectComponent, _super);
    function DepotLocationMultiSelectComponent(injector, _appConfigurationService) {
        var _this = _super.call(this, injector) || this;
        _this._appConfigurationService = _appConfigurationService;
        _this.name = 'depotLocation';
        _this.selectedItemsChange = new EventEmitter();
        _this.placeholder = _this.l('DepotLocation');
        _this.options = new Array();
        _this._selectedItems = [];
        return _this;
    }
    Object.defineProperty(DepotLocationMultiSelectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (items) {
            this._selectedItems = items || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    DepotLocationMultiSelectComponent.prototype.ngOnInit = function () {
        this.getDepotLocations();
    };
    DepotLocationMultiSelectComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (!!this.fromDepotFilter) {
            this.options = this.options.filter(function (e) {
                return e.value.toLowerCase() !== _this.fromDepotFilter.toLowerCase();
            });
        }
    };
    DepotLocationMultiSelectComponent.prototype.getDepotLocations = function () {
        var _this = this;
        this._appConfigurationService.getDepotLocations()
            .subscribe(function (res) { return _this.options = res.map(function (r) { return ({ name: r.name + " (" + r.value + ")", value: r.value }); }); });
    };
    DepotLocationMultiSelectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return DepotLocationMultiSelectComponent;
}(AppComponentBase));
export { DepotLocationMultiSelectComponent };
